export const navigation = {
    categories: [
        {
            id: 'Seating',
            name: 'Seating',
            featured: [
                {
                    name: 'Mambo Collection',
                    href: '/',
                    imageSrc: 'https://res.cloudinary.com/dz2hoghhp/image/upload/v1783267508/da5cb4ef828aca83878604b0ae8b151b503499f9-750x750_nidxg4.avif',
                    imageAlt: 'In Stock Seating',
                },
                {
                    name: 'In Stock Seating',
                    href: '/',
                    imageSrc: 'https://res.cloudinary.com/dz2hoghhp/image/upload/v1783267509/44a8f7e7ed0549e740c0eddaeef729e8852a11c8-750x750_s58ysr.avif',
                    imageAlt: 'In Stock Seating',
                }
                      ],
            sections: [
                {
                    id: 'Loveseats',
                    name: 'Sofas',
                    items: [
                        { name: 'Sectional Sofas', id: "Sectional-Sofas", href: `#` },
                        { name: 'Sleeper Sofas', id: "women_dress", href: '#' },
                        { name: 'Sleep Kit', id: 'women_jeans' },
                        { name: 'Accent Chairs', id: 'lengha_choli' }
                    ],
                },
                {
                    id: 'Loveseats',
                    name: 'Loveseats',
                    items: [
                        { name: 'Ottomans & Benches', id: 'Ottomans-Benches' },
                        { name: 'compare collections', id: 'compare-collections' },
                        { name: 'seating-accessories', id: 'seating-accessories' },
                        { name: 'All seating', id: 'seating' }
                    ],
                },
                // {
                //     id: 'brands',
                //     name: 'Brands',
                //     items: [
                //         { name: 'Full Nelson', id: '#' },
                //         { name: 'My Way', id: '#' },
                //         { name: 'Re-Arranged', id: '#' },
                //         { name: 'Counterfeit', id: '#' },
                //         { name: 'Significant Other', id: '#' },
                //     ],
                // },
            ],
        },
        {
            id: 'dining',
            name: 'Dining',
            featured: [
                {
                    name: 'Best Sellers',
                    id: '#',
                    imageSrc: 'https://res.cloudinary.com/dz2hoghhp/image/upload/v1783267508/aa35f5e2850fa35f2bd14e6033212529c11f480d-1600x1600_ot7t2j.avif',
                    imageAlt: 'Best Sellers.',
                },
                {
                    name: 'Vesper Lounge Chairs',
                    id: '#',
                    imageSrc: 'https://res.cloudinary.com/dz2hoghhp/image/upload/v1783267508/689c6f4455852a463a9cd80a6546d64a92fcc109-1600x1600_hp1pgz.avif',
                    imageAlt:
                        'Vesper Lounge Chairs',
                },
            ],
            sections: [
                {
                    id: 'clothing',
                    name: '',
                    items: [
                        { name: 'Sofas & Sectionals', id: 'Sofas_Sectionals' },
                        { name: 'Accent Chairs', id: 'Accent_Chairs' },
                        { name: 'Coffee & Side Tables', id: 'Coffee_Side_Tables' },
                        { name: 'Bookcases & Shelving', id: 'Bookcases_Shelving' },
                        { name: 'Media Consoles & Credenzas', id: 'Media Consoles & Credenzas' }

                    ],
                },
                {
                    id: 'accessories',
                    name: '',
                    items: [
                        { name: 'Ottomans & Benches', id: 'Ottomans_Benches#' },
                        { name: 'Bar Carts', id: 'Bar Carts' },
                        { name: 'Home Office', id: 'Home_Office' },
                        { name: 'Throw Pillows & Blankets', id: 'Throw_Pillows_Blankets' },
                        { name: 'Performance Ruge', id: 'Performance_Ruge' },
                    ],
                },

            ],
        },
        {
            id: 'living',
            name: 'Bedroom',
            featured: [
                {
                    name: 'Chorus Bed',
                    id: '#',
                    imageSrc: 'https://res.cloudinary.com/dz2hoghhp/image/upload/v1783267508/1b8ddaf4276f32ced00b68555b9a79152f358542-326x326_auhyvx.avif',
                    imageAlt: 'Drawstring top with elastic loop closure and textured interior padding.',
                },
                {
                    name: 'All Bedrooms',
                    id: '#',
                    imageSrc: 'https://res.cloudinary.com/dz2hoghhp/image/upload/v1783267509/ac63b0a2202ca7552a8d9bbc69e2d54cc7b2ee26-960x1200_h4lcev.avif',
                    imageAlt:
                        'Three shirts in gray, white, and blue arranged on table with same line drawing of hands and shapes overlapping on front of shirt.',
                },
            ],
            sections: [
                {
                    id: 'clothing',
                    name: '',
                    items: [
                        { name: 'Bed', id: 'bed' },
                        { name: 'Mattresses', id: 'Mattresses' },
                        { name: 'Nightstands', id: 'nightstands' },
                        { name: 'Dressers', id: 'dressers' },
                        { name: 'Benches', id: 'Benches' },
                       

                    ],
                },
                {
                    id: 'accessories',
                    name: '',
                    items: [
                        { name: 'Sheets & Bedding', id: 'Sheets & Bedding' },
                        { name: 'Performance Rugs', id: 'Performance Rugs' },
                        { name: 'Lighting', id: 'Lighting' },
                        { name: 'All Bedroom', id: 'All Bedroom' },
                    ],
                }
            ],
        },
        {
            id: 'Storage',
            name: 'Storage',
            featured: [
                {
                    name: 'Canon Collection',
                    id: '#',
                    imageSrc: 'https://res.cloudinary.com/dz2hoghhp/image/upload/v1783267508/1b8ddaf4276f32ced00b68555b9a79152f358542-326x326_auhyvx.avif',
                    imageAlt: 'Canon Collection',
                },
                {
                    name: 'Index Collections',
                    id: '#',
                    imageSrc: 'https://res.cloudinary.com/dz2hoghhp/image/upload/v1783267508/da5cb4ef828aca83878604b0ae8b151b503499f9-750x750_nidxg4.avif',
                    imageAlt:
                        'Index Collections',
                },
            ],
            sections: [
                {
                    id: 'clothing',
                    name: '',
                    items: [
                        { name: 'Wall Shelves', id: 'Wall Shelves' },
                        { name: 'Bookcases', id: 'Bookcases' },
                        { name: 'Media Consoles & Credenzas', id: 'Media Console & Credenzas' },
                        { name: 'Home Office', id: 'Home Office' },
                        { name: 'Storage Benches', id: 'Storage Benches' },
                       

                    ],
                },
                {
                    id: 'accessories',
                    name: '',
                    items: [
                        { name: 'Bar Carts & Trays', id: 'Bar Carts & Trays' },
                        { name: 'Coffee & Side tables', id: 'Coffee & Side tables' },
                        { name: 'All Storage', id: 'All Storage' },
                    ],
                }
            ],
        },
    ],
    pages: [
        { name: 'Company', id: '/' },
        { name: 'Stores', id: '/' },
    ],
}